export function columnNav(el) {

	const viewSelector = '.column-nav__inner'
	const columnSelector = '.column-nav__column'
	const itemSelector = '.column-nav__item'
	const linkSelector = '.column-nav__link'
	const backSelector = '.column-nav__back'

	const active = []
	const view = el.querySelector(viewSelector)

	function updateView(after = () => {}) {
		el.style.pointerEvents = 'none'
		el.style.setProperty('--current-depth', active.length)
		view.addEventListener('transitionend', event => {
			el.style.pointerEvents = ''
			after()
		}, { once: true })
	}

	function open(item, column) {
		active.push({ item, column })
		column.classList.add('active')
		updateView()
	}
	
	function back() {
		if (!active.length) return
		const { item, column } = active.pop()
		updateView(() => {
			column.classList.remove('active')
		})
	}

	function backToTop() {
		if (!active.length) return
		let toHide = []
		while (active.length > 0) {
		    toHide.push(active.pop())
		}
		updateView(() => {
			toHide.map(item => {
				item.column.classList.remove('active')
			})
		})
	}

	function onLinkClick(event) {
		const link = event.currentTarget
		const item = link.closest(itemSelector)
		const column = item.querySelector(columnSelector)
		if (!column) return
		event.preventDefault()
		open(item, column)
	}

	function onBackLinkClick(event) {
		event.preventDefault()
		if (!active.length) return
		back()
	}

	function setupEvents() {
		const links = [...el.querySelectorAll(linkSelector)]
		const backLinks = [...el.querySelectorAll(backSelector)]
		links.map(a => a.addEventListener('click', onLinkClick))
		backLinks.map(a => a.addEventListener('click', onBackLinkClick))
	}

	setupEvents()

	return {
		back,
		backToTop
	}
}

export default function init() {
	[...document.querySelectorAll('.column-nav')].map(el => columnNav(el))
}